// A borda entre o documento autoral e o que a API grava.
//
// TODA esquisitice do formato morre aqui (princípio do épico): as três colunas
// nuláveis, o `show_rebus` que devolve ARRAY (desembrulhado no service), o título que
// mora no JOGO e não na tabela `rebus`, e o contrato de CASE da solução — o jogo
// compara `rebus.solucao.split('')` com `inputValue.toUpperCase().split('')`
// (games/Rebus/index.tsx), então solução minúscula no banco é solução que nunca
// pontua. O resto do módulo só enxerga o `RebusDoc`.

import type { RebusSource, RebusWritePayload } from '../../../../../services/admin';
import type { RebusDoc } from './doc';

/** String vazia no lugar de nulo/indefinido/lixo — o doc é sempre de strings. */
function text(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

/**
 * A linha do `show_rebus` vira documento. `row` nulo é jogo que existe mas ainda não
 * tem rébus (jogo criado pela metade): abre o formulário vazio, já ligado ao jogo —
 * é o `idJogo` que libera o upload.
 */
export function rowToDoc(row: RebusSource | null, idJogo: number, titulo: string): RebusDoc {
  return {
    titulo,
    numeracao: text(row?.numeracao),
    solucao: text(row?.solucao),
    imagem: text(row?.imagem),
    idJogo,
  };
}

/** O documento vira corpo do replace. Sem `titulo`: ele é do jogo, e vai por
 *  `updateJogo` (ver index.tsx). */
export function docToPayload(doc: RebusDoc): RebusWritePayload {
  return {
    numeracao: doc.numeracao.trim(),
    // MAIÚSCULA com os espaços internos preservados: o jogo revela a resposta
    // palavra por palavra (`solucao.split(' ')`), então juntar tudo quebraria a dica.
    solucao: doc.solucao.trim().toUpperCase(),
    imagem: doc.imagem.trim(),
  };
}
